import React, { useState } from 'react';
import './Specialization.css';
import specializationOne from '../../../assets/Banner/AboutBanner.jpg';
import specializationTwo from '../../../assets/Banner/home-banner.png';
import specializationThree from '../../../assets/Gallery/specializationImage.jpg';
import { Link } from 'react-router-dom';

function Specialization() {
    const [selectedSpecialization, setSelectedSpecialization] = useState({
        background: specializationOne,
        header: 'Hotel Management',
        paragraph: 'With our hotel management specialization course, you can be ready in 12-18 months.',
        buttonLink: '/hotel-management',
    });

    const specializations = [
        {
            id: 1,
            background: specializationOne,
            header: 'Hotel Management',
            paragraph: 'With our hotel management specialization course, you can be ready in 12-18 months.',
            buttonLink: '/hotel-management',
        },
        {
            id: 2,
            background: specializationTwo,
            header: 'Specialization Course',
            paragraph: 'Get prepared for tourism management in just 6 months.',
            buttonLink: '/special-courses',
        },
        {
            id: 3,
            background: specializationThree,
            header: 'Foreign Languages',
            paragraph: 'Become an expert in event management with our 1-year specialization course.',
            buttonLink: '/special-courses',
        },
    ];

    const handleSpecializationClick = (id) => {
        const selected = specializations.find(spec => spec.id === id);
        setSelectedSpecialization(selected);
    };

    return (
        <div
            className='specialization-outer d-flex justify-content-center align-items-end'
            style={{ backgroundImage: `url(${selectedSpecialization.background})` }}
        >
            <div className="specialization-inner d-flex justify-content-start align-items-center">
                <div className="right-text">
                    <h2 className="header-text">{selectedSpecialization.header}</h2>
                    <p className="paragraph-text">{selectedSpecialization.paragraph}</p>
                    <div>
                        <a href={selectedSpecialization.buttonLink}>
                            <button className='cta-text'><Link to={selectedSpecialization.buttonLink}>Learn More</Link></button>
                        </a>
                    </div>
                </div>
                <div className="image-buttons">
                    {specializations.map(spec => (
                        <div
                            key={spec.id}
                            className={`specialization-image image-${spec.id} ${selectedSpecialization.id === spec.id ? 'active' : ''}`}
                            onClick={() => handleSpecializationClick(spec.id)}
                        >
                            <img src={spec.background} alt={spec.header} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Specialization;
